<template>
  <div class="time-range" v-if="time > 0">
    <p class="time-block">
      <span class="range-start">距离开始</span>
      <span class="range-text-span">
        <span class="range-text">还有</span>
        <span class="range-time-text">{{ timeRange }}</span>
      </span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'CourseTimeRange',
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      timeRange: '',
      time: '',
      timeInterval: null,
    };
  },
  watch: {
    course: {
      handler(newVal) {
        this.time = newVal.start_play_date - parseInt(new Date().getTime() / 1000);
        this.timeRange = this.$pub.timeMeter(this.time, 4, false);
        if (!this.timeInterval && this.time > 0) {
          this.timeInterval = setInterval(() => {
            this.time--;
            this.timeRange = this.$pub.timeMeter(this.time, 4, false);
          }, 1000);
        }
      },
      immediate: true,
    },
    beforeDestroy() {
      this.timeInterval && clearInterval(this.timeInterval);
    },
  },
};
</script>
<style lang="scss" scoped>
.time-range {
  .time-block {
    display: flex;
    align-items: center;
    width: 320px;
    height: 42px;
    margin: 16px 0;
    background: url('~@/assets/images/course/time-range-background.png') center no-repeat #fff;
    border-radius: 4px;
    color: #fff;
    justify-content: space-between;
    .range-start {
      color: #322323;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      line-height: 22px;
      letter-spacing: 0.02px;
      margin-right: 45px;
      margin-left: 16px;
      white-space: nowrap;
    }
    .range-text-span {
      margin-right: 16px;
      white-space: nowrap;
      .range-text {
        line-height: 22px;
        color: #322323;
        font-size: 14px;
        margin-right: 2px;
      }
      .range-time-text {
        color: #fc5623;
        white-space: nowrap;
      }
    }
  }
}
</style>
